var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-body",staticStyle:{"margin-top":"-15px"}},[_c('iframe',{ref:"iframe",attrs:{"id":"template-iframe","src":_vm.src,"height":"100%","scrolling":"yes"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }